/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RequisitoDTO } from './requisito-dto';
import { ReadinessIssueDTO } from './readiness-issue-dto';


export interface ReadinessReportDTO { 
    contesto?: ReadinessReportDTOContestoEnum;
    ready?: boolean;
    errors?: Array<ReadinessIssueDTO>;
    warnings?: Array<ReadinessIssueDTO>;
    requisiti?: Array<RequisitoDTO>;
}
export enum ReadinessReportDTOContestoEnum {
    PRE_PUBBLICAZIONE = 'PRE_PUBBLICAZIONE',
    POST_PUBBLICAZIONE = 'POST_PUBBLICAZIONE'
};



